/*
 *
 * Date: 2025
 * Description: Alert context for displaying alerts in the application
 * Author: Philippe Leroux @SKITSC
 *
 */


//Modules
import { createContext , useState , useContext } from "react";

//Interfaces
import { i_alert_control, i_promise, i_sub_main_props } from "../interfaces/utility.interface";

//Components
import AlertTop from "../components/utils/alert";

const AlertContext = createContext<{ showAlert: (a: i_promise) => void , showTopAlert: (a : i_promise) => void, closeAlert : () => void }>({ showAlert: () => {} , showTopAlert: () => {}, closeAlert : () => {} });

export const AlertProvider = (props : i_sub_main_props) => {
    const [alerts, setAlert] = useState<i_alert_control | null>(null);
    const showAlert = (alert: i_promise) => {
        const alertProps : i_alert_control = {
            alert : {
                severity : alert.type === 'Success' ? 'success' : alert.type === 'Failed'? 'error' : 'warning',
                message : alert.message,
                open : true
            },
            onClose : () => closeAlert(),
            float : 'initial',
            top : 0
        };
        setAlert(alertProps);
  };
   const showTopAlert = (alert: i_promise) => {
        const alertProps : i_alert_control = {
            alert : {
                severity : alert.type === 'Success' ? 'success' : alert.type === 'Failed'? 'error' : 'warning',
                message : alert.message,
                open : true
            },
            onClose : () => closeAlert(),
            float : 'top',
            top : 125
        };
        setAlert(alertProps);
  };

  const closeAlert = () => {
    setAlert(null);
  };

  return (
    <AlertContext.Provider value={{ showAlert , showTopAlert, closeAlert }}>
        {alerts && <AlertTop {...alerts} /> }
        {props.children}
    </AlertContext.Provider>
  );
};

export const useAlert = () => useContext(AlertContext);